export default __webpack_public_path__ + "static/media/BlueJeansTransformation.7f171fc2.png";